
import { useEffect, useState } from "react";

import { Dialog, DialogTitle, IconButton, DialogContent, Grid, Typography } from "@mui/material"

import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

interface Props{
    documento:           string;
    openDialog:          boolean;
    handleCloseDialog:   () => void;
}

export const DialogDocumento = ({ documento, openDialog, handleCloseDialog } : Props ) => {

    const [fullScreen, setFullScreen] = useState( false );

    useEffect(() => {
      
        if( openDialog ){
            setFullScreen( false );
        }

    }, [ openDialog ])    

    return (
        <Dialog 
            maxWidth="md"
            fullWidth={ true } 
            open={ openDialog } 
            fullScreen={ fullScreen } 
            onClose={ () => {} } 
        >       

            <DialogTitle sx={{ backgroundColor: '#3c3c3c', p: 0, textAlign: 'end' }}>
            
                <IconButton size='small' sx={{ color: 'white' }} onClick={ () => setFullScreen( (prev) => !prev ) }>
                    { fullScreen ? <FullscreenExitIcon /> : <FullscreenIcon /> } 
                </IconButton>

                <IconButton size='small' sx={{ color: 'white' }} onClick={ handleCloseDialog }>
                    <CloseIcon />
                </IconButton>
            
            </DialogTitle>        
            
            <DialogContent sx={{ p: 0 }}>
                
                <Grid container spacing={3} height={'100%'} >                                                
                
                    <Grid size={{ md: 12, xs: 12}} sx={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>

                        {
                            documento
                            ?
                                <iframe title='acuse' src={ documento } height={ fullScreen ? "100%" : '500px' } width="100%" style={{ border: 'none' }}></iframe>
                            :
                                <Typography variant='subtitle2' sx={{ fontSize: 18, fontWeight: 'bold', mt: 10, mb: 10 }}>
                                    No se encontró el documento
                                </Typography>                          
                        }

                    </Grid>
                    
                </Grid>
                
            </DialogContent> 

        </Dialog>  
    )
}
